module.exports = __webpack_public_path__ + "img/intro02.cb008b07.png";